import { TrainingProgramOverlay } from '#app/routes/mocra+/_form+/components/training-programs/overlay.tsx'
import { type TrainingProgramDraft } from '#app/routes/mocra+/_form+/components/training-programs/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: TrainingProgramDraft) => void
	readonly initialValue: TrainingProgramDraft
	readonly onClosed?: () => void
}

export function TrainingProgramEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<TrainingProgramOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
